import {PurchaseDetailM} from "./purchase_detail.model";
import {UserM} from "./user.model";
import {PurchaseM} from "./purchase.model";
import {ReceiptDetailM} from "./receipt_detail.model";

export class ReceiptM{
  id:number = 0
  type:number = 0
  branch_id:number = 0
  payment_term:string = ""
  settle_stm_id:number = 0;
  no:string = ""
  ref_bill_no:string = ""
  tag:string = ""
  status:string = "pending"
  price_total:number = 0
  price_total_baht:number = 0
  price_settle:number = 0
  price_settle_remaining:number = 0
  qty_total = 0
  qty_check_total = 0
  debit:number = 0
  currency = "cny"
  currency_rate = 0
  credit:number = 0
  user_id:number = 0
  seller:UserM = new UserM()
  sales1_id = 0
  sales1_name = ""
  sales2_id = 0
  sales2_name = ""
  sales_channel:string = ""
  sales_type:string = ""
  person_id:number = 0
  address:string = ""
  store_name:string = ""
  short_detail:string = ""
  firstname:string = ""
  lastname:string = ""
  tax_no:string = ""
  email:string = ""
  phone:string = ""
  mobile:string = ""
  fax:string = ""
  biv_date:string = ""
  lock_date:boolean = false
  created_at:string = ""
  updated_at:string = ""
  details: Array<ReceiptDetailM> = []
  details_original: Array<ReceiptDetailM> = []
  details_exist:Boolean = false
  selected:Boolean = false
}



// WEBPACK FOOTER //
// ./src/app/model/receipt.model.ts